<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableCloudTrailWarningDate"
      style="width: 100.1%;"
    >
      <template slot-scope="{ row, index }" slot="delete">
        <Button
          type="success"
          size="small"
          @click="rowClick(row)"
          v-hasPermission="['logs:cloudTrail:log']"
          >{{ $t("CloudTrailSecurity.operationLog") }}</Button
        >
        <Button
          type="warning"
          size="small"
          @click="addOrUpdateHandle(row.id)"
          v-hasPermission="['logs:cloudTrail:edit']"
          >{{ $t("alarms.common.edit") }}</Button
        >
        <span @click="doDelete(index)">
          <Button
            type="error"
            size="small"
            @click="cloudTrailWarningModal = true"
            v-hasPermission="['logs:cloudTrail:delete']"
            >{{ $t("alarms.common.delete") }}</Button
          >
        </span>
      </template>
    </Table>
    <!-- 操作日志详情 -->
    <alert-rule-operation-log
      v-if="alertRuleOperationLogVisible"
      ref="alertRuleOperationLog"
    ></alert-rule-operation-log>
    <!-- 删除报警规则模式框 -->
    <Modal v-model="cloudTrailWarningModal" width="360" :mask-closable="false">
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t("alarms.common.deleteConfirmation") }}</span>
      </p>
      <div style="text-align:center">
        <p>
          {{ $t("alarms.common.sureDelete") }} {{ alertRuleName }}
          {{ $t("alarms.common.what") }}?
        </p>
      </div>
      <div slot="footer">
        <Button
          type="error"
          size="large"
          long
          :loading="modal_loading"
          @click="removeCloudTrailWarning()"
          :disabled="isDisable"
          >{{ $t("alarms.common.delete") }}</Button
        >
      </div>
    </Modal>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
    <!-- 弹窗，新增/编辑 -->
    <add-or-update-cloud-trail-warning
      v-if="addOrUpdateVisible"
      ref="addOrUpdate"
    ></add-or-update-cloud-trail-warning>
  </div>
</template>
<script>
import AlertRuleOperationLog from "../../../common/AlertRuleOperationLog.vue";
import AddOrUpdateCloudTrailWarning from "../cloudTrail_monitor/AddOrUpdateCloudTrailWarning";
var tableCloudTrailWarningVue = {};
export default {
  name: "TableCloudTrailWarning",
  components: {
    AddOrUpdateCloudTrailWarning,
    AlertRuleOperationLog
  },
  data() {
    return {
      alertRuleOperationLogVisible: false,
      addOrUpdateVisible: false,
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      cloudTrailWarningModal: false,
      isDisable: false,
      modal_loading: false,
      val: "",
      alertRuleName: "",
      stateType: ["enabled", "disabled"],
      columns: [
        {
          title: this.$t("alarms.common.alertRuleName"),
          key: "alertRuleName"
        },
        {
          title: this.$t("alarms.common.status"),
          key: "state",
          render: (h, params) => {
            return h("div", [
              h(
                "i-switch",
                {
                  // 数据库0 enabled,1 disabled
                  props: {
                    type: "primary",
                    size: "large",
                    value: params.row.state == "enabled" // 控制开关的打开或关闭状态，官网文档属性是value
                  },
                  on: {
                    "on-change": () => {
                      this.switch(params.index);
                    }
                  }
                },
                [
                  h("span", {
                    slot: "open",
                    domProps: {
                      innerHTML: this.$t("alarms.common.enable")
                    }
                  }),
                  h("span", {
                    slot: "close",
                    domProps: {
                      innerHTML: this.$t("alarms.common.disable")
                    }
                  })
                ]
              )
            ]);
          }
        },
        {
          title: this.$t("alarms.common.monitorIndex"),
          key: "monitorIndexName"
        },
        {
          title: this.$t("alarms.common.alertRule"),
          key: "alertRuleDesc"
        },
        {
          title: this.$t("alarms.common.contact"),
          key: "contactNameList"
        },
        {
          title: this.$t("alarms.common.scanType"),
          key: "scanTypeName"
        },
        {
          title: this.$t("common.operation"),
          width: 200,
          slot: "delete"
        }
      ],
      tableCloudTrailWarningDate: []
    };
  },
  beforeCreate: function() {
    tableCloudTrailWarningVue = this;
  },
  created() {
    eventBus.$on("alertRuleSearchName", function(val) {
      tableCloudTrailWarningVue.alertRuleSearchName = val;
    });
    eventBus.$on("companyId", function(val) {
      tableCloudTrailWarningVue.companyId = val;
    });
  },
  mounted: function() {},
  methods: {
    showAll: function() {
      tableCloudTrailWarningVue.getCloudTrailWarningData();
    },
    // 分页显示数据
    /****************************************************/
    getCloudTrailWarningData: function() {
      //报警规则列表分页
      this.$api.alertRule
        .pageAlertRule({
          alertRuleName: tableCloudTrailWarningVue.alertRuleSearchName,
          companyId: tableCloudTrailWarningVue.companyId,
          pageNum: this.current,
          pageSize: this.pageSize,
          monitorModule: 9
        })
        .then(res => {
          this.tableCloudTrailWarningDate = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;

          for (var i = 0; i < this.tableCloudTrailWarningDate.length; i++) {
            // 状态
            this.tableCloudTrailWarningDate[i].state = this.stateType[
              this.tableCloudTrailWarningDate[i].state
            ];
          }
        });
    },
    changePage: function(current) {
      this.current = current;
      tableCloudTrailWarningVue.getCloudTrailWarningData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableCloudTrailWarningVue.getCloudTrailWarningData();
    },
    // 销毁
    beforeDestroy: function() {
      eventBus.$off("alertRuleSearchName");
    },
    // switch
    /****************************************************/
    switch(index) {
      this.index = index;
      // 打开是true,0启用 1禁用
      if (this.tableCloudTrailWarningDate[index].state == "enabled") {
        this.changeStatusMessage(
          this.tableCloudTrailWarningDate[index].id,
          "state",
          1
        );
      } else {
        this.changeStatusMessage(
          this.tableCloudTrailWarningDate[index].id,
          "state",
          0
        );
      }
    },
    // 更新反馈信息某一字段
    changeStatusMessage: function(id, key, value) {
      // 编辑状态
      this.$api.alertRule
        .changeStatus({
          id: id,
          state: value
        })
        .then(res => {
          tableCloudTrailWarningVue.getCloudTrailWarningData();
        });
    },
    // 删除
    /****************************************************/
    doDelete: function(index) {
      this.lineIndex = index;
      this.alertRuleName = this.tableCloudTrailWarningDate[index].alertRuleName;
    },
    removeCloudTrailWarning: function() {
      this.isDisable = true; //开始可以点击
      var lineIndex = this.lineIndex;
      //报警规则删除
      this.$api.alertRule
        .deleteAlertRule("id", this.tableCloudTrailWarningDate[lineIndex].id)
        .then(res => {
          this.modal_loading = true;
          setTimeout(() => {
            // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
            //21条  3页  2*10+1时删除
            if (
              lineIndex == 0 &&
              (this.current - 1) * this.pageSize + 1 == this.dataTotal
            ) {
              this.current = this.current - 1;
            }
            this.dataTotal = this.dataTotal - 1;
            tableCloudTrailWarningVue.getCloudTrailWarningData();
            this.isDisable = false;
            this.modal_loading = false;
            this.cloudTrailWarningModal = false;
            this.$Message.success(this.$t("common.deleteSuccess"));
          }, 1000);
        });
    },
    // 编辑报警规则
    /**********************************************************************************/
    addOrUpdateHandle: function(id) {
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id);
      });
    },
    // 操作日志
    /****************************************************/
    rowClick: function(row) {
      this.alertRuleOperationLogVisible = true;
      this.$nextTick(function() {
        this.$refs.alertRuleOperationLog.getAlertRuleOperationLogData(row);
      });
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/logs/cloudTrail/cloudTrail_monitor/TableCloudTrailWarning.vue